import React from 'react';
import { styles } from './MenuDivider.css';

export const MenuDivider = () => {
  return <div className={styles.divider} />;
};
